import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TeamPage} from './team.page';
import {AuthGuard} from "../../guards/auth.guard";

const routes: Routes = [
  {
    path: '',
    component: TeamPage,
    canActivate: [AuthGuard]
  },
  {
    path: 'create-team/:id',
    loadChildren: () => import('./create-team/create-team.module').then(m => m.CreateTeamPageModule)
  },
  {
    path: 'success-team',
    loadChildren: () => import('./success-team/success-team.module').then(m => m.SuccessTeamPageModule)
  },
  {
    path: 'view-team/:id',
    loadChildren: () => import('./view-team/view-team.module').then(m => m.ViewTeamPageModule)
  },
  {
    path: 'edit-team/:id',
    loadChildren: () => import('./edit-team/edit-team.module').then(m => m.EditTeamPageModule)
  },
  {
    path: 'other-team/:id',
    loadChildren: () => import('./other-team/other-team.module').then(m => m.OtherTeamPageModule)
  },
  {
    path: 'invite-team/:id/:type',
    loadChildren: () => import('./invite-team/invite-team.module').then(m => m.InviteTeamPageModule)
  },
  {
    path: 'company',
    loadChildren: () => import('../team/company/company.module').then(m => m.CompanyPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TeamPageRoutingModule {
}
